import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type {
	ApplicationLinkCreationEntity,
	ApplicationLinkCreationResponse,
} from './CommonApplicationLinkCreationEntity.tsx';

// v2/ApplicationLinkResource
export const putApplink = (
	entity: ApplicationLinkCreationEntity,
): Promise<ApplicationLinkCreationResponse> =>
	fetchJson('/rest/applinks/3.0/applicationlink', {
		method: 'PUT',
		body: JSON.stringify(entity),
		headers: {
			'Content-Type': 'application/json',
		},
	});
